


















import { defineComponent, PropType } from '@vue/composition-api'
import { MainProduct } from '@/views/catalog/CatalogProductsList.vue'
import ProductRow from '@/views/catalog/ProductRow.vue'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import PaginationProductList from '@/views/catalog/manageList/PaginationProductList.vue'

export default defineComponent({
  name: 'ProductByRowList',
  components: { PaginationProductList, ProductRow },
  props: {
    products: {
      type: Array as PropType<MainProduct[]>,
      required: true,
    },
  },
  computed: {
    productsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<MainProduct>
    },
    productsList(): any {
      console.log(this.products)
      return this.products
    },
  },
})
